import LegalPageLayout from "./LegalPageLayout";

export default function MentionsPage() {
  return (
    <LegalPageLayout
      title="Mentions légales"
      subtitle="Informations légales relatives à Echo"
      testid="page-mentions"
    >
      <section>
        <h2>Éditeur</h2>
        <p>
          L&apos;application Echo et le site theecho.fr sont édités par Echo.<br />
          Contact : <strong>support@theecho.fr</strong>
        </p>
      </section>

      <section>
        <h2>Directeur de la publication</h2>
        <p>Le représentant légal d&apos;Echo.</p>
      </section>

      <section>
        <h2>Hébergement</h2>
        <p>
          Le site est hébergé par un prestataire tiers respectueux des normes européennes de
          protection des données.
        </p>
      </section>

      <section>
        <h2>Propriété intellectuelle</h2>
        <p>
          L&apos;ensemble du contenu du site et de l&apos;application (marque, textes, visuels, code,
          design) est protégé par le droit d&apos;auteur et le droit des marques. Toute reproduction,
          représentation ou exploitation, totale ou partielle, sans autorisation expresse est interdite.
        </p>
      </section>

      <section>
        <h2>Responsabilité</h2>
        <p>
          Echo s&apos;efforce d&apos;assurer l&apos;exactitude des informations diffusées sur ce site.
          Toutefois, Echo ne peut garantir l&apos;exactitude, la précision ou l&apos;exhaustivité des
          informations mises à disposition.
        </p>
      </section>

      <section>
        <h2>Droit applicable</h2>
        <p>
          Les présentes mentions légales sont soumises au droit français. Tout litige relatif à leur
          interprétation ou exécution relève de la compétence des juridictions françaises.
        </p>
      </section>
    </LegalPageLayout>
  );
}
